import { render, staticRenderFns } from "./BackPoint.vue?vue&type=template&id=65a3a85a&"
import script from "./BackPoint.vue?vue&type=script&lang=js&"
export * from "./BackPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports